import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([]);

  let customSchema = yup.object().shape({
    name: yup
      .string()
      .trim("Name cannot include leading and trailing spaces")
      .strict(true)
      .min(2, "Name must be more than 2 characters")
      .max(225, "Name cannot exceed more than 225 characters")
      .matches(
        /^[a-zA-Z0-9].*[a-zA-Z0-9]$/,
        "Name cannot start or end with a special character"
      )
      .matches(
        /^[a-zA-Z0-9 &-]+$/,
        "Name can only contain letters, numbers, spaces, &, and hyphens"
      )
      .required("Name is required"),

    iconURL: yup
      .mixed()
      .nullable()
      .test(
        "fileType",
        "Only PNG, SVG, and JPEG files are allowed",
        (value) => {
          if (!value || !(value instanceof File)) return true;
          return ["image/png", "image/jpeg", "image/svg+xml"].includes(
            value.type
          );
        }
      ),
  });

  return defaultSchema.concat(customSchema);
};
